import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import React from "react";
import SelectAuthor from "./select.author";

export interface CommunityFilterValues {
  keyword: string;
  authorId: string;
  status: string;
  dateFrom: string;
  dateTo: string;
}

export const EMPTY_COMMUNITY_FILTER: CommunityFilterValues = {
  keyword: "",
  authorId: "",
  status: "all",
  dateFrom: "",
  dateTo: "",
};

const FilterCommunity = ({
  value,
  onChange,
}: {
  value: CommunityFilterValues;
  onChange: (value: CommunityFilterValues) => void;
}) => {
  const set = <K extends keyof CommunityFilterValues>(key: K, v: CommunityFilterValues[K]) =>
    onChange({ ...value, [key]: v });

  const hasActiveFilter =
    value.keyword !== "" ||
    value.authorId !== "" ||
    value.status !== "all" ||
    value.dateFrom !== "" ||
    value.dateTo !== "";

  return (
    <Stack spacing={2} mb={2} sx={{ width: "100%", maxWidth: "700px" }}>
      <TextField
        label="Tìm kiếm"
        placeholder="Tìm theo tiêu đề hoặc nội dung bài viết"
        size="small"
        value={value.keyword}
        onChange={(e) => set("keyword", e.target.value)}
        fullWidth
      />

      <Stack direction="row" spacing={2}>
        <Box flex={1}>
          <SelectAuthor
            selectItem={value.authorId}
            callback={(id: string) => set("authorId", id)}
          />
        </Box>

        <FormControl size="small" fullWidth sx={{ flex: 1 }}>
          <InputLabel id="community-status-label">Trạng thái</InputLabel>
          <Select
            labelId="community-status-label"
            value={value.status}
            onChange={(e) => set("status", e.target.value)}
            label="Trạng thái"
          >
            <MenuItem value="all">Tất cả</MenuItem>
            <MenuItem value="pending">Chờ duyệt</MenuItem>
            <MenuItem value="publish">Đã phê duyệt</MenuItem>
            <MenuItem value="rejected">Đã từ chối</MenuItem>
          </Select>
        </FormControl>
      </Stack>

      <Stack direction="row" spacing={2} alignItems="center">
        <TextField
          label="Từ ngày"
          type="date"
          size="small"
          value={value.dateFrom}
          onChange={(e) => set("dateFrom", e.target.value)}
          InputLabelProps={{ shrink: true }}
          fullWidth
        />
        <TextField
          label="Đến ngày"
          type="date"
          size="small"
          value={value.dateTo}
          onChange={(e) => set("dateTo", e.target.value)}
          InputLabelProps={{ shrink: true }}
          fullWidth
        />
        <Button
          variant="text"
          size="small"
          disabled={!hasActiveFilter}
          onClick={() => onChange(EMPTY_COMMUNITY_FILTER)}
          sx={{ whiteSpace: "nowrap" }}
        >
          Xóa bộ lọc
        </Button>
      </Stack>
    </Stack>
  );
};

export default FilterCommunity;
